import { dynamicFieldProperties } from "./dynamicFieldProperties";

export class ui_field_state<T> {
  value?: T;
  hasError?: boolean;
  isVisible?: boolean;
  isRequired?: boolean;
  errorLabel?: string;
  disabled?: boolean;
  label?: string;
  maxLength?: number;
  requiredRoles?: string[];
  editableInSteps?: number[];

  constructor(item?: dynamicFieldProperties) {
    // default
    this.hasError = false;

    //
    const defaultValue: any = item?.default_value;
    this.value = defaultValue;
    this.isVisible = item?.visible ?? false;
    this.isRequired = item?.mandatory ?? false;
    this.errorLabel = item?.error_label ?? "";
    this.disabled = !(item?.editable ?? true);
    this.label = item?.field_message_id ?? "";

    const parsed = parseInt(item?.max_length, 10);
    this.maxLength = isNaN(parsed) ? 0 : parsed;
    this.requiredRoles = this.setRequiredRoles(item?.required_roles);
    this.editableInSteps = item?.editable_in_steps ?? [];
  }

  private setRequiredRoles = (rolesString: string) => {
    const requiredRoles = rolesString ? rolesString?.split(";") ?? [] : [];
    return requiredRoles;
  };
}
